import { AxiosError } from 'axios';
import { useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router';

import { IVerifySignUpOtpData } from '../../../models/auth/verifySignUpOtp.model';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { ACCOUNT, SIGNUP_VERIFICATION_CONFIRMATION } from '../../../routes/routeConstants';
import useHttps from '../../useHttps';

const useSignupVerificationOtp = () => {
  const request = useHttps();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [otpErrorBanner, setOtpErrorBanner] = useState(false);

  const debounceRef = useRef<any>(null);

  const onSignUpError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(err?.response?.data?.message ?? 'Something went wrong');

    setOtpErrorBanner(true);

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => setOtpErrorBanner(false), 3000);
  };

  const onSignUpVerificationSuccess = ({ data }: SuccessHttpResponse<any>) => {
    navigate(`/${ACCOUNT}/${SIGNUP_VERIFICATION_CONFIRMATION}`, {
      replace: true,
      state: { data: data },
    });
  };

  const signupVerificationOtp = (data: IVerifySignUpOtpData) => {
    const url: HttpConfig = {
      url: 'api/v1/auth/verify-account',
      method: 'post',
      data,
    };

    request(url, onSignUpVerificationSuccess, setLoading, onSignUpError);
  };

  return {
    loading,
    signupVerificationOtp,
    otpErrorBanner
  };
};

export default useSignupVerificationOtp;
